import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PayrollResultsDataTable from './PayrollResultsDataTable'

const PayrollResults = () => {
  return (
    <Box width="full" flexDirection="column" padding="s24">
      <Box gap="s6" flexDirection="row" paddingBottom="s24">
        <Text.Normal weight="bold">
          {i18n.t('bookkeepers.clients.payroll_dashboard.title')}
        </Text.Normal>
      </Box>
      <PayrollResultsDataTable />
    </Box>
  )
}

export default PayrollResults
